import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';

export const FlexRow = styled.div`
   display: ${(props) => (props.display ? `${props.display}` : 'flex')};
  align-items: ${(props) =>
    props.alignItems ? `${props.alignItems}` : 'center'};
  flex-direction: row;
  row-gap: ${(props) => (props.RowGap ? `${props.RowGap}px` : '15px')}
  padding-left: ${(props) =>
    props.paddingLeft ? `${props.paddingLeft}px` : '0px'};
  padding-top: ${(props) =>
    props.paddingTop ? `${props.paddingTop}px` : '0px'};
  margin-left: ${(props) =>
    props.marginLeft ? `${props.marginLeft}px` : '0px'};
  ${(props) => (props.height ? `height: ${props.height}px;` : '')};
`;

export const FlexColumn = styled.div`
  display: flex;
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  flex-direction: column;
  align-items: ${(props) =>
    props.alignItems ? `${props.alignItems}` : 'center'};
  padding-left: ${(props) =>
    props.paddingLeft ? `${props.paddingLeft}px` : '00px'};
  padding-top: ${(props) =>
    props.paddingTop ? `${props.paddingTop}px` : '0px'};
`;

export const BreadcrumbsBox = styled.div`
  padding: 10px 0 10px 14px;
  background-color: ${(props) =>
    props.backgroundColor ? `${props.backgroundColor}` : '#efefef'};
`;

export const StyledLink = styled(Link)`
  text-decoration: underline;
`;

export const Wrapper = styled.div`
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '800px')};
`;

export const ControlLabelContainer = styled.div`
  flex: 1;
  display: flex;
  padding-right: 45px;

  > label {
    min-width: 90px;
    margin-bottom: 0;
    padding-top: ${(props) =>
      props.paddingTop ? `${props.paddingTop}px` : '00px'};
    padding-right: ${(props) =>
      props.paddingRight ? `${props.paddingRight}px` : '00px'};
  }

  > span {
    min-width: 90px;
    margin-bottom: 0;
    margin-right: 10;
    padding-top: ${(props) =>
      props.paddingTop ? `${props.paddingTop}px` : '00px'};
    padding-right: ${(props) =>
      props.paddingRight ? `${props.paddingRight}px` : '00px'};
  }
`;

const Loader = styled.div`
  display: flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.backgroundColor ? `${props.backgroundColor}` : 'unset'};
`;

export const Loading = () => (
  <Loader>
    <CircularProgress />
  </Loader>
);

export const YesNoContainer = styled.div`
  display: flex;
  padding-top: ${(props) =>
    props.paddingTop ? `${props.paddingTop}px` : '00px'};
  padding-left: ${(props) =>
    props.paddingLeft ? `${props.paddingLeft}px` : '00px'};

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .MuiFormLabel-root {
    margin-right: 20px;
  }
`;
